var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var ExclamationIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 10,
    glyphHeight: 53
  }), React.createElement("path", {
    d: "M0.826248 35.5215L9.17407 35.5215L9.17408 0.649414L0.826251 0.649413L0.826248 35.5215Z"
  }), React.createElement("path", {
    d: "M0.826251 52.2178L9.17407 52.2178L9.17407 43.8699L0.826252 43.8699L0.826251 52.2178Z"
  }));
};
export var ExclamationIconGlyph = function (props) {
  return React.createElement(ExclamationIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};